import StatisticsApiService from './_services/StatisticsApiService';

import {
  generateStatisticsByMachines,
  generateSubstratesStatistics,
  generateOperatorsStatistics,
  generateReprintsStatisticsByMachines,
  generateTotalStatistics,
} from './_models/statisticsData';

export default {
  namespaced: true,
  state: {
    statisticsByMachines: [],
    substratesStatistics: [],
    operatorsStatistics: [],
    reprintsStatistics: [],
    totalStatistics: [],
  },
  mutations: {
    setStatisticsByMachines(state, payload) {
      state.statisticsByMachines = payload;
    },
    setSubstratesStatistics(state, payload) {
      state.substratesStatistics = payload;
    },
    setOperatorsStatistics(state, payload) {
      state.operatorsStatistics = payload;
    },
    setReprintsStatistics(state, payload) {
      state.reprintStatistics = payload;
    },
    setTotalStatistics(state, payload) {
      state.totalStatistics = payload;
    },
  },
  actions: {
    async getStatistics({ commit }, {
      suffix, startDate, endDate, machines, operators,
    }) {
      const data = await StatisticsApiService.getStatistics({
        suffix,
        startDate,
        endDate,
      });
      const operatorsStatistics = generateOperatorsStatistics(data.countsByOperator, operators);
      const substratesStatistics = generateSubstratesStatistics(data.countsBySubstrate);
      const statisticsByMachines = generateStatisticsByMachines(data.counts, machines);
      const reprintsStatistics = generateReprintsStatisticsByMachines(
        data.reprintCountsByMachine,
        machines,
      );
      const totalStatistics = generateTotalStatistics(statisticsByMachines);

      commit('setStatisticsByMachines', statisticsByMachines);
      commit('setSubstratesStatistics', substratesStatistics);
      commit('setOperatorsStatistics', operatorsStatistics);
      commit('setReprintsStatistics', reprintsStatistics);
      commit('setTotalStatistics', totalStatistics);
    },
  },
};
